import { useTheme } from '@material-ui/core'
import React from 'react'
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts'

export default function BarGraph(props) {
  const theme = useTheme()
  const { data } = props
  const { palette: { primary, secondary } } = theme

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        width={500}
        height={300}
        data={data}
        barGap={10}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        barSize={35}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <defs>
          <linearGradient id="color4" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={secondary.dark} stopOpacity={1} />
            <stop offset="95%" stopColor={secondary.main} stopOpacity={1} />
          </linearGradient>
        </defs>
        <defs>
          <linearGradient id="color5" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={primary.main} stopOpacity={1} />
            <stop offset="95%" stopColor={primary.dark} stopOpacity={1} />
          </linearGradient>
        </defs>
        <Bar label={{ position: 'top' }} radius={4} dataKey="credit" fill="url(#color4)" opacity={0.8} />
        <Bar label={{ position: 'top' }} radius={4} dataKey="debit" fill="url(#color5)" opacity={0.8} />
      </BarChart>
    </ResponsiveContainer>
  )
}
